import React from "react";
import { Button, ButtonGroup } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextButtonGroupVertical = () => {
  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Vertical Text button group"}
        value={
          '<ButtonGroup variant={"text"} orientation="vertical" aria-label="text primary vertical button group">\n\t<Button>One</Button>\n\t<Button>Two</Button>\n\t<Button>Three</Button>\n</ButtonGroup>'
        }
      >
        <ButtonGroup
          variant={"text"}
          orientation="vertical"
          aria-label="text primary vertical button group"
        >
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
        </ButtonGroup>
      </PreviewAndEditor>
    </>
  );
};

export default TextButtonGroupVertical;
